var _rect, _defs, _defs2, _defs3, _defs4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginWaveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 540,
    fill: "#0c62e3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "43.8%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#001d4a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#001d4a",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "43.8%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#001d4a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#0c62e3",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "56.3%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#001d4a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#001d4a",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "56.3%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#0c62e3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#001d4a",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 432C-55 425.4 -110 418.9 -165.3 399.1C-220.6 379.4 -276.2 346.4 -298.4 298.4C-320.6 250.4 -309.4 187.3 -326.1 135.1C-342.8 82.8 -387.4 41.4 -432 0L0 0Z",
    fill: "#003e93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 216C-27.5 212.7 -55 209.4 -82.7 199.6C-110.3 189.7 -138.1 173.2 -149.2 149.2C-160.3 125.2 -154.7 93.7 -163.1 67.5C-171.4 41.4 -193.7 20.7 -216 0L0 0Z",
    fill: "#001d4a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -432C48.3 -399 96.7 -365.9 141.2 -340.9C185.7 -315.9 226.5 -298.8 272.9 -272.9C319.4 -247 371.6 -212.3 399.1 -165.3C426.6 -118.4 429.3 -59.2 432 0L0 0Z",
    fill: "#003e93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -216C24.2 -199.5 48.3 -183 70.6 -170.5C92.9 -157.9 113.2 -149.4 136.5 -136.5C159.7 -123.5 185.8 -106.1 199.6 -82.7C213.3 -59.2 214.6 -29.6 216 0L0 0Z",
    fill: "#001d4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginWaveDark);
export default __webpack_public_path__ + "static/media/loginWaveDark.1c31e2386e8228abd60298d1d99ab2d0.svg";
export { ForwardRef as ReactComponent };